export default __webpack_public_path__ + "static/quotes-f9a32d140d59664a42ffcfc253e9fba7.svg";